import { styled } from "styled-components";

export const Icon = styled.span<{ $selfColoured?: Maybe<boolean> }>`
  display: inline-block;
  ${({ $selfColoured }) => ($selfColoured ? "" : "color: inherit;")}
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  & > * {
    line-height: 1;
  }
  & svg {
    display: inline-block;
    height: 1em;
    width: 1em;
    ${({ $selfColoured }) => ($selfColoured ? "" : "fill: currentColor;")}
  }
`;
